"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomTheme = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _theme = require("./theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useCustomTheme = function useCustomTheme(colors) {
  return _objectSpread(_objectSpread({}, _theme.theme), {}, {
    colors: colors
  });
};

exports.useCustomTheme = useCustomTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VDdXN0b21UaGVtZSIsImNvbG9ycyIsInRoZW1lIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnRleHRzL1RoZW1lL3VzZUN1c3RvbVRoZW1lLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHRoZW1lIH0gZnJvbSAnLi90aGVtZSc7XG5pbXBvcnQgdHlwZSB7IFRoZW1lLCBUaGVtZUNvbG9ycyB9IGZyb20gJy4vdHlwZXMnO1xuXG5leHBvcnQgY29uc3QgdXNlQ3VzdG9tVGhlbWUgPSAoY29sb3JzOiBUaGVtZUNvbG9ycyk6IFRoZW1lID0+ICh7XG4gIC4uLnRoZW1lLFxuICBjb2xvcnMsXG59KTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7O0FBR08sSUFBTUEsY0FBYyxHQUFHLFNBQWpCQSxjQUFpQixDQUFDQyxNQUFEO0VBQUEsdUNBQ3pCQyxZQUR5QjtJQUU1QkQsTUFBTSxFQUFOQTtFQUY0QjtBQUFBLENBQXZCIn0=